import React from 'react';
import 'rc-steps/assets/index.css'
import 'rc-steps/assets/iconfont.css'
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import Steps, { Step } from 'rc-steps';


class FormStepper extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            waiting: false
        }
    }

    handleStepClick(index) {
        let category = "";
        Object.keys(this.props.categoryProgression).forEach(key => {
            if (this.props.categoryProgression[key].number - 1 === index) category = key;
        })
        this.props.onClick(category);
    }


    render() {

            const categoryProgression = this.props.categoryProgression;
            const translate = this.props.translate;
            var _this = this
            // var width = 0
            // var title = ""
            // const user = JSON.parse(localStorage.getItem("user"))

            // if (this.props.consultant && this.props.consultant.content.progression) {
            //     width = this.props.consultant.content.progression;
            // }
            // if (this.props.consultant && this.props.consultant.user) {
            //     title = this.props.consultant.user.profile.firstName + " " + this.props.consultant.user.profile.lastName
            // }
            const icons = {
                finish: <div style={{ height: '100%' }}><i style={{ height: '100%' }} className="fas fa-check"></i></div>,
                error: <div style={{ height: '100%' }}><i style={{ height: '100%' }} className="fas fa-times"></i></div>,
            };
            let steps = [];
            let categoryProgressionArray = [];
            let currentStep = Object.keys(categoryProgression).length;
            Object.keys(categoryProgression).forEach(function (key) {
                let obj = categoryProgression[key];
                obj.key = key === "school" ?  "formation" : key;
                categoryProgressionArray.push(obj);
            });
            categoryProgressionArray.sort((a, b) => a.number - b.number);
            categoryProgressionArray.forEach(function (category, index) {
                steps.push(<Step key={category.number} onStepClick={_this.handleStepClick.bind(_this)} title={translate("content." + category.key + ".title")} />);
                if (!category.complete && index < currentStep) {
                    currentStep = index;
                }
            });
            return (
                <div>
                    <Steps current={currentStep} icons={icons} labelPlacement={"vertical"}>
                        {steps}
                    </Steps>
                </div>
            )
        
    }
}

const mapStateToProps = state => ({
    message: state.consultant.message,
})


export default connect(mapStateToProps, null)(withLocalize(FormStepper));
